import { ReactNode } from 'react';

interface EmptyStateProps {
  image: {
    src: string;
    alt: string;
    srcSet?: string;
    sizes?: string;
    priority?: boolean;
  };
  title: string;
  description: string;
  actions?: ReactNode;
  className?: string;
}

export const EmptyState = ({
  image,
  title,
  description,
  actions,
  className = '',
}: EmptyStateProps) => {
  return (
    <section
      aria-label={`Estado - ${title}`}
      className={`flex flex-col items-center justify-center w-full h-full min-h-[500px] ${className}`}
    >
      <div className='mb-2'>
        <img
          src={image.src}
          alt={image.alt}
          decoding='async'
          sizes={image.sizes}
          srcSet={image.srcSet}
          loading={image.priority ? 'eager' : 'lazy'}
          fetchPriority={image.priority ? 'high' : 'low'}
          aria-hidden='false'
          className='w-md h-64 object-contain user-select-none select-none pointer-events-none'
        />
      </div>

      <div className='text-center mb-4'>
        <h2 className='text-3xl font-bold text-content-neutral-primary mb-2'>{title}</h2>
        <p className='text-content-neutral-secondary'>{description}</p>
      </div>

      {actions && <div className='flex gap-4 justify-center'>{actions}</div>}
    </section>
  );
};
